import { Component, computed, input, output } from '@angular/core';
import { Button, ButtonSize, ButtonType, ButtonVariant } from '@ntv360/component-pantry';

/**
 * A button built on top of the ntv-button, with additional feature where we can add icon using the iconKey from sprite
 * instead of hardcoding the svg
 */
@Component({
    selector: 'app-button',
    imports: [Button],
    templateUrl: './button.component.html',
    styleUrl: './button.component.scss',
})
export class ButtonComponent {
    /**
     * Button variant
     */
    public readonly variant = input<ButtonVariant>('accent');

    /**
     * Button size
     */
    public readonly size = input<ButtonSize>('lg');

    /**
     * Button type
     */
    public readonly type = input<ButtonType>('button');

    /**
     * Custom color for the text and outline
     */
    public readonly customColor = input<string>('');

    /**
     * Whether the button is disabled
     */
    public readonly disabled = input<boolean>(false);

    /**
     * Button label
     */
    public readonly label = input<string>('');

    /**
     * Button iconKey, points to the icon sprite
     */
    public readonly iconKey = input<string>('');

    /**
     * Icon size. Default is `12 x 12`
     */
    public readonly iconSize = input<{ width: number; height: number }>({
        width: 12,
        height: 12,
    });

    /**
     * Gap between the label and text in tailwind-css class. Defaults to `gap-2`
     */
    public readonly gap = input<string>('gap-2');

    /**
     * Button type computed signal. Internally used ONLY
     */
    protected btnType = computed<ButtonType>(() => {
        if (!this.label()) {
            return 'fab';
        }
        return this.type();
    });

    /**
     * Icon and label gap computed signal. Internally used ONLY
     */
    protected btnGap = computed<string>(() => {
        if (!this.label()) {
            return '';
        }
        return this.gap();
    });

    /**
     * Button size computed signal. Internally used ONLY
     */
    protected btnSize = computed<ButtonSize>(() => {
        if (!this.label()) {
            return 'md';
        }
        return this.size();
    });

    /**
     * Emit when button is clicked
     */
    public readonly buttonClick = output<PointerEvent>();

    /**
     * On button click
     */
    protected onClick(event: PointerEvent) {
        this.buttonClick.emit(event);
    }
}
